import { useState } from "react";
import "../addition/addition.css";

export default function DivisionConfig({ onStart }) {
  const [modalType, setModalType] = useState(null);

  const [dividendSize, setDividendSize] = useState(2);
  const [divisorSize, setDivisorSize] = useState(1);
  const [speed, setSpeed] = useState(600);

  return (
    <div className="addition-container">
      <div className="config-card">
        <div className="config-title">Division</div>

        <div className="row clickable" onClick={() => setModalType("dividend")}>
          <span>Dividend Size</span>
          <span>{dividendSize} ▼</span>
        </div>

        <div className="row clickable" onClick={() => setModalType("divisor")}>
          <span>Divisor Size</span>
          <span>{divisorSize} ▼</span>
        </div>

        <div className="row">
          <span>Flickering Speed</span>

          <div className="speed-control">
            <button
              onClick={() => setSpeed(Math.max(200, speed - 50))}
              className="speed-btn minus"
            >
              -
            </button>

            <span className="speed-value">{speed} ms</span>

            <button
              onClick={() => setSpeed(Math.min(950, speed + 50))}
              className="speed-btn plus"
            >
              +
            </button>
          </div>
        </div>
      </div>

      <div className="button-group">
        <button
          className="btn-primary"
          onClick={() =>
            onStart({
              dividendSize,
              divisorSize,
              speed,
              type: "division"
            })
          }
        >
          Start
        </button>
      </div>

      {/* Modal */}
      {modalType && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <strong>{modalType === "dividend" ? "Dividend Size" : "Divisor Size"}</strong>
              <p>Option to select</p>
            </div>

            <div className="modal-options">
              {modalType === "dividend" &&
                [2, 3, 4, 5].map((item) => (
                  <div
                    key={item}
                    className={`option ${dividendSize === item ? "selected" : ""}`}
                    onClick={() => {
                      setDividendSize(item);
                      if (divisorSize >= item) {
                        setDivisorSize(item - 1);
                      }
                      setModalType(null);
                    }}
                  >
                    {item}
                  </div>
                ))}

              {modalType === "divisor" &&
                Array.from({ length: dividendSize - 1 }, (_, i) => i + 1).map((num) => (
                  <div
                    key={num}
                    className={`option ${divisorSize === num ? "selected" : ""}`}
                    onClick={() => {
                      setDivisorSize(num);
                      setModalType(null);
                    }}
                  >
                    {num}
                  </div>
                ))}
            </div>

            <div className="cancel" onClick={() => setModalType(null)}>
              Cancel
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
